export default "/images/vk.svg?088a576ec5f5f54c794fb0fb7feeb46c";